/**
 * Returns boolean based on the existence of the item.masterdId in the upsellItemsMap
 * @param {{[masterId]: boolean}} upsellItemsMap
 * @returns {function(*, *): (boolean|*)}
 */
export const filterCartUpsellInfo = (upsellItemsMap) => (_, item) => {
  if (!upsellItemsMap) return true
  return upsellItemsMap[item.masterId] || false
}
